import { Fragment } from 'react';
import { Box, Button, Divider } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { OfferFormData, emptyOffer } from './offers/offerForm';
import OfferCard from './offers/OfferCard';

export type { OfferFormData } from './offers/offerForm';

interface OffersStepProps {
  offers: OfferFormData[];
  onOffersChange: (offers: OfferFormData[]) => void;
  usedOfferIndices: Set<number>;
  isRecurring: boolean;
  isPreEdited: boolean;
  isCashdesk: boolean;
}

function CampaignOffersStep({ offers, onOffersChange, usedOfferIndices, isRecurring, isPreEdited, isCashdesk }: OffersStepProps) {
  const updateOffer = (id: string, patch: Partial<OfferFormData>) =>
    onOffersChange(offers.map(o => (o.id === id ? { ...o, ...patch } : o)));

  return (
    <Box sx={{ p: 3, width: '100%' }}>
      {offers.map((offer, index) => (
        <Fragment key={offer.id}>
          {index > 0 && <Divider sx={{ my: 3 }} />}
          <OfferCard
            offer={offer}
            index={index}
            isUsed={usedOfferIndices.has(index)}
            isRecurring={isRecurring}
            isPreEdited={isPreEdited}
            isCashdesk={isCashdesk}
            onChange={patch => updateOffer(offer.id, patch)}
            onRemove={() => onOffersChange(offers.filter(o => o.id !== offer.id))}
          />
        </Fragment>
      ))}

      <Divider sx={{ mt: 3, mb: 2 }} />
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => onOffersChange([...offers, emptyOffer(String(Date.now()))])}
        sx={{
          backgroundColor: 'primary.main',
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': { backgroundColor: 'primary.main', opacity: 0.9 },
        }}
      >
        Ajouter une offre
      </Button>
    </Box>
  );
}

export default CampaignOffersStep;
